import { create } from "zustand";

export type IamDashTab = "orgs" | "templates" | "people" | "invites";

interface IamDashboardState {
  activeTab: IamDashTab;
  setActiveTab: (tab: IamDashTab) => void;
}

export const useIamDashboardStore = create<IamDashboardState>((set) => ({
  activeTab: "orgs",
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
